import { Budget } from '@/domain/models'

export const budgetLimit = (budget: Budget, monthlyIncome: number): number => {
  if (budget.amountKind === 'fixed') return budget.amount
  if (monthlyIncome <= 0) return 0
  return (budget.amount / 100) * monthlyIncome
}
